<template>
  <div>
    <div v-if="benutzerStatus.updatingUser || benutzerStatus.changingPasswort" class="text-center">
      <b-spinner variant="primary" type="grow"></b-spinner>
    </div>
    <div v-else>
      <b-tabs content-class="mt-3">
        <b-tab title="Persönliches" active>
          <b-form @submit.prevent="profilBearbeiten" class="text-left">
            <b-form-row>
              <b-col>
                <b-form-group id="anrede-group" label="Anrede *" label-for="anrede">
                  <b-form-select
                    id="anrede"
                    v-model="benutzerDaten.geschlecht"
                    :state="geschlechtState"
                    required
                  >
                    <option value="m">Herr</option>
                    <option value="w">Frau</option>
                    <option value="d">Sonstige</option>
                  </b-form-select>
                </b-form-group>

                <b-form-group id="vorname-group" label="Vorname *" label-for="vorname">
                  <b-form-input
                    id="vorname"
                    v-model="benutzerDaten.vorname"
                    type="text"
                    :state="vornameState"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="name-group" label="Name *" label-for="name">
                  <b-form-input
                    id="name"
                    v-model="benutzerDaten.name"
                    type="text"
                    :state="nameState"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="geburtsdatum-group" label="Geburtsdatum" label-for="geburtsdatum">
                  <b-form-input
                    id="geburtsdatum *"
                    v-model="date"
                    type="date"
                    :state="geburtstadumState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
              <b-col>
                <b-button
                  @click="$bvModal.hide(`profilBearbeiten`)"
                  variant="secondary"
                  class="mr-3"
                >Abbrechen</b-button>
                <b-button
                  type="submit"
                  variant="success"
                  class="float-right"
                  v-bind:disabled="!persoenlichesValidation"
                >Speichern</b-button>
              </b-col>
            </b-form-row>
          </b-form>
        </b-tab>

        <b-tab title="Anschirft">
          <b-form @submit.prevent="profilBearbeiten" class="text-left">
            <b-form-row>
              <b-col>
                <b-form-group
                  id="strasse-group"
                  label="Straße und Hausnummer *"
                  label-for="strasse"
                >
                  <b-form-input
                    id="strasse"
                    v-model="benutzerDaten.strasse"
                    type="text"
                    :state="strasseState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col cols="4">
                <b-form-group id="plz-group" label="PLZ *" label-for="plz">
                  <b-form-input
                    id="plz"
                    v-model="benutzerDaten.plz"
                    type="text"
                    :state="plzState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="8">
                <b-form-group id="ort-group" label="Ort *" label-for="ort">
                  <b-form-input
                    id="ort"
                    v-model="benutzerDaten.ort"
                    type="text"
                    :state="ortState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              <b-col>
                <b-form-group id="land-group" label="Land *" label-for="land">
                  <b-form-input
                    id="land"
                    v-model="benutzerDaten.land"
                    type="text"
                    :state="landState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-row>
              <b-col>
                <b-button
                  @click="$bvModal.hide(`profilBearbeiten`)"
                  variant="secondary"
                  class="mr-3"
                >Abbrechen</b-button>
                <b-button
                  type="submit"
                  variant="success"
                  class="float-right"
                  v-bind:disabled="!anschriftValidation"
                >Speichern</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>

        <b-tab title="Kontaktinformationen">
          <b-form @submit.prevent="profilBearbeiten" class="text-left">
            <b-form-row>
              <b-col cols="5">
                <b-form-group id="tel-group" label="Telefonnummer *" label-for="tel">
                  <b-form-input
                    id="tel"
                    v-model="benutzerDaten.tel"
                    type="text"
                    :state="telState"
                    required
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="fax-group" label="Fax" label-for="fax">
                  <b-form-input id="fax" v-model="benutzerDaten.fax" type="text" :state="faxState"></b-form-input>
                </b-form-group>

                <b-form-group id="mobil-group" label="Mobilnummer" label-for="mobil">
                  <b-form-input
                    id="mobil"
                    v-model="benutzerDaten.mobil"
                    type="text"
                    :state="mobilState"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="email-group" label="E-Mail Adresse *" label-for="email">
                  <b-form-input
                    id="email"
                    v-model="benutzerDaten.email"
                    type="email"
                    :state="emailState"
                    required
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="5" offset="2">
                <b-form-group id="telG-group" label="Telefonnummer 2" label-for="telG">
                  <b-form-input
                    id="telG"
                    v-model="benutzerDaten.telG"
                    type="text"
                    :state="telGState"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="faxG-group" label="Fax 2" label-for="faxG">
                  <b-form-input
                    id="faxG"
                    v-model="benutzerDaten.faxG"
                    type="text"
                    :state="faxGState"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="mobilG-group" label="Mobilnummer 2" label-for="mobilG">
                  <b-form-input
                    id="mobilG"
                    v-model="benutzerDaten.mobilG"
                    type="text"
                    :state="mobilGState"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="emailG-group" label="E-Mail Adresse 2" label-for="emailG">
                  <b-form-input
                    id="emailG"
                    v-model="benutzerDaten.emailG"
                    type="email"
                    :state="emailGState"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-row>
              <b-col>
                <b-button
                  @click="$bvModal.hide(`profilBearbeiten`)"
                  variant="secondary"
                  class="mr-3"
                >Abbrechen</b-button>
                <b-button
                  type="submit"
                  variant="success"
                  class="float-right"
                  v-bind:disabled="!anschriftValidation || !kontaktinformationValidation"
                >Speichern</b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>

        <b-tab title="Bild">
          <b-row>
            <b-col>
              <div
                v-if="benutzerStatus.gettingUserImage || benutzerStatus.uploadingUserImage"
                class="text-center"
              >
                <b-spinner variant="primary" type="grow"></b-spinner>
              </div>
              <div v-else class="text-center">
                <b-img
                  v-if="benutzerBild"
                  thumbnail
                  fluid
                  :src="`data:${benutzerBild.contentType};base64,${benutzerBild.image}`"
                  alt="Profil Bild"
                  class="mb-3 img-size"
                ></b-img>
                <b-img
                  v-else
                  thumbnail
                  fluid
                  :src="require('../../../assets/profile.png')"
                  alt="file 1"
                ></b-img>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-file
                v-model="file"
                placeholder="Wählen Sie ein Profilbild"
                class="mb-2"
                accept="image/*"
              ></b-form-file>
              <b-button
                v-if="file"
                variant="primary"
                @click="uploadBild"
                class="float-right"
              >Bild hochladen</b-button>
            </b-col>
          </b-row>
        </b-tab>

        <b-tab title="SMS Provider">
          <b-form @submit.prevent="createSmsProvider" class="text-left">
            <b-form-group id="sms-host-group" label="Host" label-for="sms-host">
              <b-form-input id="sms-host" v-model="benutzerDaten.smsHost" type="text"></b-form-input>
            </b-form-group>
            
            <b-form-group id="sms-user-id-group" label="Benutzer Id" label-for="user-id">
              <b-form-input
                id="user-id"
                v-model="benutzerDaten.smsUserId"
                type="text"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="sms-api-key-group" label="Api Key" label-for="api-key">
              <b-form-input
                id="api-key"
                v-model="benutzerDaten.smsApiKey"
                type="password"
              ></b-form-input>
            </b-form-group>


            <div>
              <b-button
                @click="$bvModal.hide(`profilBearbeiten`)"
                variant="secondary"
                class="mr-3"
              >Abbrechen</b-button>
              <b-button type="submit" variant="success" class="float-right">Speichern</b-button>
            </div>
          </b-form>
        </b-tab>

        <b-tab title="Email Client">
          <b-form @submit.prevent="profilBearbeiten" class="text-left">
            <b-form-row>
              <b-col class="mr-4">
                <h4>SMTP</h4>
                <b-form-group id="smtp-server-group" label="SMTP Server" label-for="smtp-server">
                  <b-form-input id="smtp-server" v-model="benutzerDaten.smtpServer" type="text"></b-form-input>
                </b-form-group>
                
                <b-form-group id="smtp-port-group" label="SMTP Port" label-for="smtp-port">
                  <b-form-input
                    id="smtp-port"
                    v-model="benutzerDaten.smtpPort"
                    type="text"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="smtp-username-group" label="SMTP Benutzername" label-for="smtp-username">
                  <b-form-input
                    id="smtp-username"
                    v-model="benutzerDaten.smtpUsername"
                    type="text"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="smtp-password-group" label="SMTP Passwort" label-for="smtp-password">
                  <b-form-input
                    id="smtp-password"
                    v-model="benutzerDaten.smtpPassword"
                    type="password"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <h4>POP 3</h4>
                <b-form-group id="pop-server-group" label="POP3 Server" label-for="pop-server">
                  <b-form-input id="pop-server" v-model="benutzerDaten.popServer" type="text"></b-form-input>
                </b-form-group>
                
                <b-form-group id="pop-port-group" label="POP3 Port" label-for="pop-port">
                  <b-form-input
                    id="pop-port"
                    v-model="benutzerDaten.popPort"
                    type="text"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="pop-username-group" label="POP3 Benutzername" label-for="pop-username">
                  <b-form-input
                    id="pop-username"
                    v-model="benutzerDaten.popUsername"
                    type="text"
                  ></b-form-input>
                </b-form-group>

                <b-form-group id="pop-password-group" label="POP3 Passwort" label-for="pop-password">
                  <b-form-input
                    id="pop-password"
                    v-model="benutzerDaten.popPassword"
                    type="password"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-form-row>

            <div>
              <b-button
                @click="$bvModal.hide(`profilBearbeiten`)"
                variant="secondary"
                class="mr-3"
              >Abbrechen</b-button>
              <b-button type="submit" variant="success" class="float-right">Speichern</b-button>
            </div>
          </b-form>
        </b-tab>

        <b-tab title="Passwort ändern">
          <b-form @submit.prevent="passwortÄndern()" class="text-left">
            <b-form-group
              id="altes-passwort-group"
              label="Altes Passwort"
              label-for="altes-passwort"
            >
              <b-form-input
                id="altes-passwort"
                v-model="changePasswortData.altesPasswort"
                type="password"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="neues-passwort-group"
              label="Neues Passwort"
              label-for="neues-passwort"
            >
              <b-form-input
                id="neues-passwort"
                v-model="changePasswortData.neuesPasswort"
                type="password"
                required
              ></b-form-input>
            </b-form-group>
            <div>
              <b-button
                @click="$bvModal.hide(`profilBearbeiten`)"
                variant="secondary"
                class="mr-3"
              >Abbrechen</b-button>
              <b-button type="submit" variant="success" class="float-right">Passwort ändern</b-button>
            </div>
          </b-form>
        </b-tab>
        <b-tab title="Konto löschen">
          <b-button variant="danger" @click="benutzerLoeschen()" class="mr-2">Konto löschen</b-button>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'profilBearbeiten',
  props: ['benutzerDaten'],
  computed: {
    ...mapGetters(['benutzer', 'benutzerStatus', 'benutzerBild']),
    geschlechtState() {
      if (this.benutzerDaten.geschlecht === null) {
        return null;
      } else if (
        this.benutzerDaten.geschlecht.toLowerCase() === "m" ||
        this.benutzerDaten.geschlecht.toLowerCase() === "w" ||
        this.benutzerDaten.geschlecht.toLowerCase() === "d"
      ) {
        return true;
      } else {
        return false;
      }
    },
    vornameState() {
      if (this.benutzerDaten.vorname === "") return null;

      return this.benutzerDaten.vorname.length > 2 ? true : false;
    },
    nameState() {
      if (this.benutzerDaten.name === "") return null;

      return this.benutzerDaten.name.length > 2 ? true : false;
    },
    geburtstadumState() {
      if (this.benutzerDaten.geburtsdatum === "") return null;

      return true;
    },
    strasseState() {
      if (this.benutzerDaten.strasse === "") return null;

      return this.benutzerDaten.strasse.length > 2 ? true : false;
    },
    plzState() {
      if (this.benutzerDaten.plz === "") return null;

      return this.benutzerDaten.plz.length > 2 ? true : false;
    },
    ortState() {
      if (this.benutzerDaten.ort === "") return null;

      return this.benutzerDaten.ort.length > 2 ? true : false;
    },
    landState() {
      if (this.benutzerDaten.land === "") return null;

      return this.benutzerDaten.land.length > 0 ? true : false;
    },
    telState() {
      if (this.benutzerDaten.tel === "") return null;

      return this.benutzerDaten.tel.length > 2 ? true : false;
    },
    faxState() {
      if (this.benutzerDaten.fax === "") return null;

      return this.benutzerDaten.fax.length > 2 ? true : false;
    },
    mobilState() {
      if (this.benutzerDaten.mobil === "") return null;

      return this.benutzerDaten.mobil.length > 2 ? true : false;
    },
    emailState() {
      if (this.benutzerDaten.email === "") return null;

      return this.emailRegex.test(this.benutzerDaten.email) ? true : false;
    },
    telGState() {
      if (this.benutzerDaten.telG === "") return null;

      return this.benutzerDaten.telG.length > 2 ? true : false;
    },
    faxGState() {
      if (this.benutzerDaten.faxG === "") return null;

      return this.benutzerDaten.faxG.length > 2 ? true : false;
    },
    mobilGState() {
      if (this.benutzerDaten.mobil === "") return null;

      return this.benutzerDaten.mobil.length > 2 ? true : false;
    },
    emailGState() {
      if (this.benutzerDaten.emailG === "") return null;

      return this.emailRegex.test(this.benutzerDaten.emailG) ? true : false;
    },
    persoenlichesValidation() {
      if (
        this.geschlechtState &&
        this.vornameState &&
        this.nameState &&
        this.geburtstadumState
      ) {
        return true;
      } else {
        return false;
      }
    },
    anschriftValidation() {
      if (
        this.strasseState &&
        this.plzState &&
        this.ortState &&
        this.landState
      ) {
        return true;
      } else {
        return false;
      }
    },
    kontaktinformationValidation() {
      if (this.telState && this.emailState) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(['updateBenutzer', 'changePasswort', 'deleteBenutzer', 'getBenutzerBild', 'uploadBenutzerBild', 'smsProvider']),
    profilBearbeiten () {
      this.benutzerDaten.geburtstag = this.date
      this.updateBenutzer(this.benutzerDaten)
        .then(() => {
          this.date = ''

          const toastData = {
            title: '', 
            msg: 'Die Änderungen wurden gespeichert.',
            variant: 'success'
          };

          if (this.benutzerStatus.errMsg) {
            toastData.title = 'Es ist etwas schief gelaufen.', 
            toastData.msg = this.benutzerStatus.errMsg;
            toastData.variant = "danger";
          }

          this.$emit('profilBearbeitenToast', toastData);

          if (!this.benutzerStatus.errMsg) {
            this.$bvModal.hide("profilBearbeiten")
          }
        })
    },
    passwortÄndern () {
      this.changePasswort(this.changePasswortData)
        .then(() => {
          this.changePasswortData = {}

          const toastData = {
            title: '', 
            msg: 'Die Passwort wurden geändert.',
            variant: 'success'
          }

          if (this.benutzerStatus.errMsg) {
            toastData.title = 'Es ist etwas schief gelaufen.', 
            toastData.msg = this.benutzerStatus.errMsg;
            toastData.variant = "danger"
          }

          this.$emit('profilBearbeitenToast', toastData);

          if (!this.benutzerStatus.errMsg) {
            this.$bvModal.hide(`profilBearbeiten`)
          }
        })
    },
    uploadBild() {
      var fd = new FormData();
      fd.append("file", this.file);
      this.uploadBenutzerBild(fd).then(() => {
        this.getBenutzerBild();

        this.file = null;

        const toastData = {
          title: "",
          msg: "Das Bild wurde gespeichert.",
          variant: "success"
        };

        if (this.benutzerStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.kontakteStatus.errMsg);
          toastData.variant = "danger";
        }

        this.$emit('profilBearbeitenToast', toastData);

        if (!this.benutzerStatus.errMsg) {
          this.$bvModal.hide(`profilBearbeiten`)
        }
      });
    },
    createSmsProvider() {
      const smsProviderData = {
        smsHost: this.benutzer.smsHost || "",
        smsApiKey: this.benutzer.smsApiKey || "",
        smsUserId: this.benutzer.smsUserId || ""
      }

      this.smsProvider(smsProviderData)
        .then(() => {
          const toastData = {
            title: '', 
            msg: 'Der SMS Provider wurde hinterlegt.',
            variant: 'success'
          }

          if (this.benutzerStatus.errMsg) {
            toastData.title = 'Es ist etwas schief gelaufen.'
            toastData.msg = 'Eingegebene Daten sind nicht korrekt.'
            toastData.variant = "danger"
          }

          this.$emit('profilBearbeitenToast', toastData);

          if (!this.benutzerStatus.errMsg) {
            this.$bvModal.hide(`profilBearbeiten`)
          }
        })
    },
    benutzerLoeschen() {
      if (
        confirm("Sind Sie sicher, dass sie das Konto entgülig löschen wollen ?")
      ) {
        this.deleteBenutzer().then(() => {
          const toastData = {
            title: "",
            msg: "Das Benutzerkonto wurde erfolgreich gelöscht.",
            variant: "success"
          };
          if (this.benutzerStatus.errMsg) {
            toastData.title = "Es ist etwas schief gelaufen.";
            toastData.msg = this.benutzerStatus.errMsg;
            toastData.variant = "danger";
          }

          this.$emit('profilBearbeitenToast', toastData);

          if (!this.benutzerStatus.errMsg) {
            this.$bvModal.hide(`profilBearbeiten`)
          }
        });
      }
    }
  },
  data () {
    return {
      emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
      date: '',
      changePasswortData: {},
      file: null
    }
  },
  mounted () {
    this.date = new Date(this.benutzerDaten.geburtsdatum)
    this.date = this.date.getFullYear()+ '-' + ('0' + (this.date.getMonth() + 1)).slice(-2) + '-'+ ('0' + this.date.getDate()).slice(-2)
  }
}
</script>

<style scoped>
.img-size {
  max-height: 25em;
}
</style>